export default "__VITE_ASSET__fc1a2462__"